import { render, staticRenderFns } from "./CreateDeliveryNote.vue?vue&type=template&id=4ae98bc2&lang=pug&"
import script from "./CreateDeliveryNote.vue?vue&type=script&lang=ts&"
export * from "./CreateDeliveryNote.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDeliveryNote.vue?vue&type=style&index=0&id=4ae98bc2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports